import TermSelect from './TermSelect';

export default TermSelect;
